import Keyboard from "react-simple-keyboard";
import { TecladoNumericoContainer } from "./localStyle";
import "react-simple-keyboard/build/css/index.css";

/*
  Componente: TecladoNumerico
  Descripción: Teclado virtual únicamente numérico con Enter y Borrar.
  Uso: visible en tablet/desktop; Enter dispara acción provista por props.
*/
const TecladoNumerico = ({
  onChange,
  onEnter,
  enterStr = "Aceptar",
  modeLight,
  onDelete,
}) => {
  const onKeyPress = (button) => {
    if (button === "{enter}") return onEnter && onEnter();
    if (button === "{bksp}") return onDelete && onDelete();
  };

  const layout = ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {enter}"];

  return (
    <TecladoNumericoContainer modeLight={modeLight}>
      <Keyboard
        layoutName={"default"}
        onChange={onChange}
        theme={"hg-theme-default myTheme1"}
        onKeyPress={onKeyPress}
        layout={{ default: layout }}
        display={{
          "{enter}": enterStr,
          "{bksp}": "Borrar",
        }}
        buttonTheme={[
          {
            class: modeLight ? "hg-white" : "hg-latex10",
            buttons: "1 2 3 4 5 6 7 8 9 0",
          },
          {
            class: "hg-broccoli",
            buttons: "{enter}",
          },
          {
            class: "hg-danger",
            buttons: "{bksp}",
          },
        ]}
      />
    </TecladoNumericoContainer>
  );
};

export default TecladoNumerico;
